import React, { useState } from 'react'
import { COMMON_ATTRIBUTE_VALUES } from '../utils/Constants'

type CommonAttributeValuesProps = {
    attributeValues: string[]
}

const CommonAttributeValues = ({ attributeValues }: CommonAttributeValuesProps) => {
    const [showContent, setShowContent] = useState<boolean>(false);

    const handleButtonClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        e.stopPropagation();
        setShowContent((prev) => !prev);
    }

    return (
        <div className="tw-flex tw-flex-col tw-w-full">
            <div className="tw-flex tw-justify-between tw-items-center">
                <div className="tw-text-[#97A0AF] tw-font-semibold">{COMMON_ATTRIBUTE_VALUES}</div>
                {!attributeValues || attributeValues.length === 0 ? 0 : <button
                    onClick={handleButtonClick}
                    className="tw-text-[#0747a6] tw-text-xs tw-font-semibold tw-leading-tight"
                >
                    {showContent ? 'Hide' : 'Show'}
                </button>}
            </div>

            {showContent && attributeValues && attributeValues.length > 0 ? (
                <div className="tw-mt-2 tw-flex tw-flex-wrap tw-gap-2.5">
                    {attributeValues?.map((value) => (
                        <div key={value} className="tw-self-stretch tw-px-[5px] tw-bg-[#dadbdd] tw-rounded-sm tw-justify-center tw-items-center tw-gap-2.5 tw-inline-flex">
                            <div className="tw-text-[#172b4d] tw-text-xs">
                                {value}
                            </div>
                        </div>
                    ))}
                </div>
            ) : showContent && (
                <div className="tw-text-gray-500">No attribute values available</div>
            )}
        </div>
    );
}
export default CommonAttributeValues